import { Box } from '@mui/material'
import { alpha, useTheme } from '@mui/material/styles'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

type FilterPillProps = {
  label: string
  value: string
  active?: boolean
  onClick?: () => void
}

/** Rounded label:value filter chip with a chevron (no-op / local UI). */
export default function FilterPill({ label, value, active, onClick }: FilterPillProps) {
  const theme = useTheme()
  const c = theme.affexy.colors

  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        gap: 0.75,
        alignItems: 'center',
        px: 1.5,
        py: 0.75,
        borderRadius: `${theme.affexy.radii.pill}px`,
        bgcolor: active ? alpha(c.coral, 0.06) : c.white,
        border: `1px solid ${active ? alpha(c.coral, 0.35) : c.ink08}`,
        fontFamily: theme.affexy.fonts.body,
        fontSize: 12.5,
        cursor: 'pointer',
      }}
    >
      <Box component="span" sx={{ color: active ? c.coral : c.ink56, fontWeight: 500 }}>
        {label}:
      </Box>
      <Box component="span" sx={{ color: c.ink, fontWeight: 700 }}>
        {value}
      </Box>
      <ExpandMoreIcon sx={{ fontSize: 14, color: active ? c.coral : c.ink56 }} />
    </Box>
  )
}
